import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  codeWrapper: {
    '&&': {
      position: 'relative',

      marginBottom: SPACES.l,
      padding: `44px ${SPACES.xxxxxl} ${SPACES.xxxxl}`,

      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
  },
  roundBorder: {
    '&&': {
      boxShadow: `10px 10px 20px ${theme.palette.custom.grey}`,
      borderRadius: '15px',
    },
  },
  localeWrapper: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  codeTitle: {
    '&&': {
      marginBottom: SPACES.xxxxxl,

      fontWeight: FONTS.WEIGHTS.medium,
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.357,

      textAlign: 'center',

      color: theme.palette.custom.darkBlue2,
    },
  },
  codeImage: {
    '&&': {
      marginBottom: '2.5rem',
      padding: '2.5rem',
      backgroundColor: 'white',

      width: 200,
      height: 200,
    },
  },
  textWrapper: {
    '&&': {
      marginBottom: SPACES.xxxxl,
    },
  },
  textTitle: {
    '&&': {
      marginBottom: SPACES.xxxs,

      fontSize: FONTS.SIZES.s,
      lineHeight: 1.333,
      color: theme.palette.custom.grey2,
    },
  },
  textValue: {
    '&&': {
      marginBottom: SPACES.xxl,

      fontWeight: FONTS.WEIGHTS.medium,
      fontSize: FONTS.SIZES.xl,
      lineHeight: 1.388,

      color: theme.palette.custom.darkBlue2,
    },
  },
  button: {
    '&&': {
      width: 150,
      height: 40,

      boxShadow: `2px 4px 8px ${theme.palette.custom.grey}`,
      borderRadius: '20px',
    },
  },
  buttonIcon: {
    '&&': {
      fill: theme.palette.custom.white,
      width: 18,
      height: 18,
    },
  },
  buttonText: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.333,
      textTransform: 'none',

      color: theme.palette.custom.white,
    },
  },
  buttonsWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: SPACES.xs,
    },
  },
  urlsContainer: {
    marginTop: SPACES.xxxxxl,

    [theme.breakpoints.up('tablet')]: {
      paddingLeft: SPACES.xs,
    },
  },
  urlsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xs,
  },
  title: {
    '&&': {
      color: theme.palette.custom.grey2,
      lineHeight: 1.33,

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.s,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xs,
      },
    },
  },
  text: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
      lineHeight: 1.33,

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.s,
        fontWeight: FONTS.WEIGHTS.medium,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xs,
        fontWeight: FONTS.WEIGHTS.medium,
      },
    },
  },
}))

export default useStyles
